import React, { useMemo } from 'react';

import { Button, ButtonGroup, StandardButton } from '@eika/button';
import { CheckboxGroup } from '@eika/checkbox';
import { WarningLabel } from '@eika/label';

import useTranslation from '../../../../../hooks/useTranslation';
import { EikaModal } from '../../../../EikaModal';
import { useTransactionFilterContext } from '../../TransactionFilterContext/TransactionFilterContext';

type Props = {
    open: boolean;
    onClose: () => void;
};

const MobileCategoryModal: React.FC<Props> = ({ open, onClose }) => {
    const { transactionCategory } = useTransactionFilterContext();
    const translation = useTranslation();

    const categoryCheckboxes = useMemo(() => {
        return transactionCategory.data.map((x) => ({ ...x, checked: transactionCategory.value.includes(x.value) }));
    }, [transactionCategory]);

    return (
        <EikaModal
            contentShouldStretch
            id="category-submodal"
            open={open}
            setOpen={() => null}
            onClose={onClose}
            footerContent={
                <ButtonGroup
                    className="transaction-filter-form__sub-submit-wrapper transaction-filter-form__sub-submit-wrapper--no-spacing"
                    primaryAction={
                        <Button className="margin-top-auto-button" type="button" onClick={onClose}>
                            {translation.transactionFilter.choose}
                        </Button>
                    }
                    hideSecondaryAction={transactionCategory.value.length === 0}
                    secondaryAction={
                        <StandardButton buttonType="negative" onClick={() => transactionCategory.reset()}>
                            {translation.transactionFilter.removeChosen}
                        </StandardButton>
                    }
                />
            }
        >
            <section className="modal-content">
                <section>
                    {transactionCategory.data && (
                        <>
                            <CheckboxGroup
                                className="transaction-filter-form__category-wrapper"
                                label={translation.transactionFilter.chooseCategory}
                                options={categoryCheckboxes}
                            />
                            {transactionCategory.warningMessage && (
                                <WarningLabel text={transactionCategory.warningMessage} />
                            )}
                        </>
                    )}
                </section>
            </section>
        </EikaModal>
    );
};

export default MobileCategoryModal;
